import { Grid } from "@material-ui/core";
import React from "react";
import { Text, Button, SVG, Modal } from "sunrise-ui";
import "./Users.scss";

import { makeStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";

//---for api-------------
import { useDispatch, useSelector } from "react-redux";
import { getAllUserData, deleteUserData } from "../../redux/reducers/users";
import { AppDispatch } from "../../redux/store";
import { uiSliceActions } from "../../redux/reducers/uiState";

import EnlargeImage from "./EnlargeImage";
import UserDetailDrawer from "./UserDetailDrawer";
import toaster from "../../utilities/toaster";
import Loader from "../../utilities/Loader";
import moment from "moment";
import NoDataScreen from "../../utilities/NoDataScreen";
import { CSVLink } from "react-csv";

const useStylesForTable = makeStyles({
  table: {
    minWidth: 650,
    width: "max-content",
  },
});

const ManageUser = ({ userType }: { userType: any }) => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  // ------------ for table---------------
  React.useEffect(() => {
    setLoading(true);
    dispatch(getAllUserData({ endPoint: "admin/get-user" })).then((res) => {
      setLoading(false);
    });
  }, [dispatch]);
  const allUsersData = useSelector((state: any) => state.USERS.allUserData);
  const [userData, setUserData] = React.useState([]);
  React.useEffect(() => {
    let filteredData: any = [];
    if (userType === "P & M") {
      filteredData =
        allUsersData &&
        allUsersData?.filter((item: any) => item?.role === "p&m");
    } else {
      allUsersData &&
        allUsersData?.forEach((item: any) => {
          if (
            item.role.toLowerCase().replace("-", " ") ===
            userType.toLowerCase().replace("-", " ")
          ) {
            filteredData.push(item);
          }
        });
    }
    const activeUsers = filteredData.filter((val: any) => val?.isActive);
    const inActiveUsers = filteredData.filter((val: any) => !val?.isActive);
    filteredData = activeUsers.concat(inActiveUsers);
    setUserData(filteredData);
    setRows(filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType, allUsersData]);

  const [rows, setRows] = React.useState<any>(userData);
  const tableClasses = useStylesForTable();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [searchVal, setSearchVal] = React.useState([]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filterData = (e: any) => {
    if (e.target.value !== "") {
      setSearchVal(e.target.value);
      const filterTable = rows.filter(
        (item: any) =>
          item?.name?.toLowerCase()?.includes(e.target.value.toLowerCase()) ||
          item?.subContractor?.companyName
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase()) ||
          item?.subContractor?.ownerName
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase()) ||
          item?.emailId
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase()) ||
          item?.mobileNumber?.primaryNumber
            ?.toString()
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase())
      );
      setRows(filterTable);
    } else {
      setSearchVal(e.target.value);
      setRows(userData);
    }
  };
  // ---------------for enlarge image modal-------------

  const [modalData, setModalData] = React.useState({
    image: "",
    isOpen: false,
  });

  const handleOpen = (photo: string) => {
    setModalData({ ...modalData, image: photo, isOpen: true });
  };

  //-----modal state--------
  const [open, setOpen] = React.useState(false);
  const [modalText, setModalText] = React.useState("");
  const [handleCallData, setHandleCallData] = React.useState({
    type: "",
    userID: "",
    userDetail: {},
  });
  //------modal handler
  const handleModal = (type: string, userID: string, userDetail: any) => {
    setOpen(true);
    setHandleCallData({
      type: type,
      userID: userID,
      userDetail: userDetail,
    });
    type === "edit"
      ? setModalText(`Are you sure you want to edit this ${userDetail?.role}?`)
      : setModalText(
          `Are you sure you want to remove this ${userDetail?.role}?`
        );
  };
  //----modal YES button handler
  const handleCall = () => {
    setOpen(false);
    if (handleCallData?.type === "remove") {
      let myObj = {};
      dispatch(
        deleteUserData({
          endPoint: `admin/user-inactive/${handleCallData?.userID}`,
          data: myObj,
        })
      );
      setTimeout(function () {
        setLoading(true);
        dispatch(getAllUserData({ endPoint: "admin/get-user" })).then((res) => {
          setLoading(false);
        });
      }, 1000);
    } else if (handleCallData?.type === "edit") {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      dispatch(uiSliceActions.setUserState(handleCallData));
    }
  };
  //-----For Show User Detail in right Drawer--------
  const [drawerData, setDrawerData] = React.useState({
    details: {},
    isOpen: false,
  });
  const handleShowUserDetail = (detail: any) => {
    setDrawerData({ ...drawerData, details: detail, isOpen: true });
  };

  //----for excel download
  const [dataToDownload, setDataToDownload] = React.useState<any>([]);
  React.useEffect(() => {
    if (rows && rows?.length > 0) {
      let myArray: any = [];
      rows?.forEach((item: any) => {
        if (item?.role?.toLowerCase().replace("-", " ") !== "sub contractor") {
          let myObj = {
            name: item?.name,
            email: item?.emailId,
            role: item?.role,
            primary_mobile: item?.mobileNumber?.primaryNumber,
            alternate_mobile: item?.mobileNumber?.secondaryNumber,
            user_image: item?.userImage,
          };
          myArray.push(myObj);
        } else {
          let myObj = {
            representative_name: item?.subContractor?.ownerName,
            role: item?.role,
            type: item?.subContractor?.type,
            primary_mobile: item?.mobileNumber?.primaryNumber,
            alternate_mobile: item?.mobileNumber?.secondaryNumber,
            aadhaar_image: item?.aadhar?.image,
            pan_image: item?.pan?.image,
          };
          myArray.push(myObj);
        }
      });
      setDataToDownload(myArray);
    }
  }, [rows]);

  const checkMultipleExpire = (projects: any) => {
    return projects.some(
      (val: any) =>
        new Date().getTime() <= new Date(val.toDate).getTime() ||
        val?.toDate === null
    );
  };

  const removeUser = (row: any) => {
    if (userType?.toLowerCase() !== "sub-contractor") {
      if (
        row?.currentProject &&
        row?.currentProject?.projectId &&
        row?.currentProject?.projectId !== ""
      ) {
        toaster(
          "error",
          `This ${row?.role} is assigned to project, So can't remove.`
        );
      } else {
        handleModal("remove", row?._id, row);
      }
    } else {
      if (
        row?.multipleCurrentProjects.length > 0 &&
        checkMultipleExpire(row?.multipleCurrentProjects)
      ) {
        toaster(
          "error",
          `This ${row?.role} is assigned to project, So can't remove.`
        );
      } else {
        handleModal("remove", row?._id, row);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid
          container
          className="manage_users_wrapper bg--white box--shadow mt2 mb1"
        >
          <Grid item xs={12}>
            <Grid container className="d-flex v-center sb mt">
              <Grid>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt0 p1"
                >
                  Manage {userType !== "" ? userType : "User"}
                </Text>
              </Grid>
              {allUsersData?.length > 0 && (
                <Grid className="d-flex sb v-center relative">
                  <div className="searchIcon_box absolute">
                    <SVG type={"searchIcon"} />
                  </div>
                  <div className="search_box mr-1">
                    <input
                      type="search"
                      id="tableSearch"
                      name="tableSearch"
                      placeholder="Search"
                      value={searchVal}
                      onChange={filterData}
                    />
                  </div>
                  <div className="mr-1 pointer">
                    <CSVLink data={dataToDownload} filename="UserDetail">
                      <SVG type={"download"} isActive={true} />
                    </CSVLink>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} className="candidate_table">
            {allUsersData?.length > 0 ? (
              <TableContainer>
                <Table className={tableClasses.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        {userType?.toLowerCase().replace("-", " ") ===
                        "sub contractor"
                          ? "Representative Name"
                          : `${userType} Name`}
                      </TableCell>
                      {userType?.toLowerCase().replace("-", " ") ===
                      "sub contractor" ? (
                        <TableCell className="f14 fw500" align="left">
                          Sub-Contractor Company Name
                        </TableCell>
                      ) : (
                        <></>
                      )}
                      <TableCell className="f14 fw500" align="left">
                        Email Id
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        Phone Number
                      </TableCell>
                      {userType?.toLowerCase().replace("-", " ") !==
                      "sub contractor" ? (
                        <TableCell className="f14 fw500" align="left">
                          Alternate Contact Number
                        </TableCell>
                      ) : (
                        <></>
                      )}
                      {userType?.toLowerCase().replace("-", " ") ===
                      "sub contractor" ? (
                        <TableCell className="f14 fw500" align="left">
                          Type of Sub-Contractor
                        </TableCell>
                      ) : (
                        <></>
                      )}
                      <TableCell className="f14 fw500" align="left">
                        {userType !== "" &&
                        userType?.toLowerCase().replace("-", " ") !==
                          "sub contractor"
                          ? userType
                          : "PAN Card"}{" "}
                        Photo
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        Last Updated At
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        Action/Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {rows?.length > 0 ? (
                    <TableBody>
                      {rows &&
                        rows
                          ?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: any, index: number) => (
                            <TableRow key={index}>
                              <TableCell component="th" scope="row">
                                <Text
                                  type="link"
                                  fonts="normal"
                                  className="mb0 mt0 capitalize"
                                  onTextClick={() => {
                                    handleShowUserDetail(row);
                                  }}
                                >
                                  {userType?.toLowerCase().replace("-", " ") ===
                                  "sub contractor"
                                    ? row?.subContractor?.ownerName
                                    : row?.name}
                                </Text>
                              </TableCell>
                              {userType?.toLowerCase().replace("-", " ") ===
                              "sub contractor" ? (
                                <TableCell className="f14 fw400" align="left">
                                  {row?.subContractor?.companyName}
                                </TableCell>
                              ) : (
                                <></>
                              )}
                              <TableCell className="f14 fw400" align="left">
                                {row?.emailId}
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {row?.mobileNumber?.primaryNumber}
                              </TableCell>
                              {userType?.toLowerCase().replace("-", " ") !==
                              "sub contractor" ? (
                                <TableCell className="f14 fw400" align="left">
                                  {row?.mobileNumber?.secondaryNumber || ""}
                                </TableCell>
                              ) : (
                                <></>
                              )}
                              {userType?.toLowerCase().replace("-", " ") ===
                              "sub contractor" ? (
                                <TableCell className="f14 fw400" align="left">
                                  {row?.subContractor?.type}
                                </TableCell>
                              ) : (
                                <></>
                              )}
                              <TableCell className="f14 fw400" align="left">
                                {
                                  <img
                                    src={
                                      userType
                                        ?.toLowerCase()
                                        .replace("-", " ") === "sub contractor"
                                        ? row?.pan?.image
                                        : row?.userImage
                                    }
                                    alt="..."
                                    className="candidate_photo pointer"
                                    onClick={() => {
                                      handleOpen(
                                        userType
                                          ?.toLowerCase()
                                          .replace("-", " ") ===
                                          "sub contractor"
                                          ? row?.pan?.image
                                          : row?.userImage
                                      );
                                    }}
                                  />
                                }
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {moment(row?.updatedAt).format(
                                  "DD,MMM,YYYY, h:mm A"
                                )}
                              </TableCell>
                              <TableCell align="left">
                                {row?.isActive ? (
                                  <Grid className="action_buttons_box d-flex v-center">
                                    <Button
                                      type="button"
                                      size="small"
                                      isRounded={true}
                                      category="primary"
                                      onClick={() => {
                                        handleModal("edit", row?._id, row);
                                      }}
                                      className="mr-1 f14"
                                    >
                                      Edit
                                    </Button>
                                    <Button
                                      type="button"
                                      size="small"
                                      isRounded={true}
                                      category="warning"
                                      onClick={() => removeUser(row)}
                                      className="f14"
                                    >
                                      Remove
                                    </Button>
                                  </Grid>
                                ) : (
                                  <Text
                                    type="normal"
                                    fonts="normal"
                                    className="mt0 mb0 fw500 unassign"
                                  >
                                    Removed!
                                  </Text>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={13} align="center">
                        No Data Found
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={rows?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            ) : (
              <NoDataScreen text="There are no data available to manage" />
            )}
            {/* -------modal---- */}
            <Grid item xs={12}>
              <Modal
                image="modalImage"
                call={() => {
                  handleCall();
                }}
                reset={() => {
                  setOpen(false);
                }}
                openModal={open}
                title={modalText}
                showImageModal={false}
              />
            </Grid>
            {/* ---------------Enlarge Image Modal---------- */}
            <EnlargeImage modalData={modalData} />

            {/* --------------Drawer modal-------------------- */}
            <UserDetailDrawer drawerData={drawerData} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ManageUser;
